import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type MemberDownloads } from "./types";

export default {
  init: (apiInfo: ModuleApiInfo): Promise<HttpApiResponse<MemberDownloads.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/downloads`)
};
